/**
 * page-header-description-toggle.js
 * ---------------------------------------------------------------------------
 * "More" / "Less" toggle for the collection description in the page header.
 *
 * The description is clamped to 2 lines in CSS. This reveals a More button ONLY
 * when the copy actually overflows that clamp (measured, not guessed), so a short
 * description never gets a pointless "More" that expands to nothing.
 *
 * Clicking adds .is-expanded, which drops the clamp; the label flips to "Less".
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var EXPANDED = 'is-expanded';
  var VISIBLE = 'is-visible';

  function init() {
    var desc = document.querySelector('.PageHeader__Description');
    var btn = document.querySelector('[data-description-toggle]');
    if (!desc || !btn) return;

    var header = document.getElementById('PageHeader');

    // The header height feeds --tg-page-header-height (used for sticky offsets),
    // so it has to be refreshed whenever expanding changes the header's height.
    function syncHeaderHeight() {
      if (header) {
        document.documentElement.style.setProperty(
          '--tg-page-header-height',
          header.offsetHeight + 'px'
        );
      }
    }

    // While clamped, an overflowing description has scrollHeight > clientHeight.
    // 1px of slack absorbs sub-pixel rounding.
    function isTruncated() {
      return desc.scrollHeight - desc.clientHeight > 1;
    }

    function refresh() {
      if (desc.classList.contains(EXPANDED)) return; // can't measure while expanded
      if (isTruncated()) btn.classList.add(VISIBLE);
      else btn.classList.remove(VISIBLE);
    }

    btn.addEventListener('click', function () {
      var expanded = desc.classList.toggle(EXPANDED);
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      var label = btn.querySelector('[data-description-label]') || btn;
      label.textContent = expanded
        ? btn.getAttribute('data-label-less')
        : btn.getAttribute('data-label-more');
      syncHeaderHeight();
    });

    refresh();

    // Re-measure when the line count can change.
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        refresh();
        syncHeaderHeight();
      }, 150);
    });

    // A late-loading webfont changes the metrics, and therefore whether the copy
    // overflows two lines. Re-measure once fonts settle.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        refresh();
        syncHeaderHeight();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
